import {EditCategories} from './edit-categories';

export default EditCategories;
